import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React from 'react';
import { SVGFill } from '../../svg';
import { Icon } from '../../icon';
var basicPath = 'M21.0621 24.8118L21.6111 25.497V40.5H26.3889V25.4984L26.9364 24.8137L28.8889 26.375V43H19.1111V26.375L21.0621 24.8118ZM40.7902 7.50158C37.9551 11.0405 34.4916 15.3686 31.7371 18.8117C30.3598 20.5333 29.1596 22.0338 28.3038 23.1039L26.9364 24.8137C26.9363 24.8138 26.9364 24.8137 28.8889 26.375C28.8889 26.375 37.0723 16.141 42.7415 9.0644C44.0533 7.42687 42.8856 5 40.7874 5H7.19653C5.10115 5 3.93401 7.41986 5.24303 9.05604C10.9049 16.133 19.1111 26.375 19.1111 26.375C21.0621 24.8118 21.0622 24.8119 21.0621 24.8118L19.6916 23.101C18.8338 22.0303 17.6311 20.529 16.2516 18.8065C13.4938 15.3634 10.0294 11.0369 7.19976 7.5H40.7874C40.7881 7.5 40.7887 7.5 40.7894 7.50001C40.7896 7.50051 40.7899 7.50104 40.7902 7.50158Z';
var filledPath = 'M7.19653 5C5.10115 5 3.93401 7.41986 5.24303 9.05604C10.9049 16.133 19.1111 26.375 19.1111 26.375V43H28.8889V26.375C28.8889 26.375 37.0723 16.141 42.7415 9.0644C44.0533 7.42687 42.8856 5 40.7874 5H7.19653Z';
var FilterIcon = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var iconFill = _ref.iconFill,
      props = _objectWithoutProperties(_ref, ["iconFill"]);

  var path = basicPath;

  if (iconFill && iconFill === 'fill') {
    path = filledPath;
  }

  return /*#__PURE__*/React.createElement(Icon, _extends({
    ref: ref
  }, props), /*#__PURE__*/React.createElement(SVGFill, {
    d: path
  }));
});
FilterIcon.displayName = 'FilterIcon';
FilterIcon.defaultProps = {
  'aria-label': 'Filter'
};
export default FilterIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/theme/dist/esm/icons/FilterIcon/index.js
// module id = 1844
// module chunks = 12